import { render } from "./Countdown.vue?vue&type=template&id=423a8087&scoped=true"
import script from "./Countdown.vue?vue&type=script&lang=js"
export * from "./Countdown.vue?vue&type=script&lang=js"

import "./Countdown.vue?vue&type=style&index=0&id=423a8087&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-423a8087"

export default script